import { render } from "./crud-user.vue?vue&type=template&id=620d91d6&scoped=true&ts=true&lang=pug"
import script from "./crud-user.vue?vue&type=script&lang=ts"
export * from "./crud-user.vue?vue&type=script&lang=ts"

import "./crud-user.vue?vue&type=style&index=0&id=620d91d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620d91d6"]])

export default __exports__